module.exports = __webpack_public_path__ + "static/media/market-research-validation-first.6b659121.jpg";